import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const AltVinContent = ({ vin, isMobile }) => {
	const labels = useLabels();
	const vinLabel = labels.get('VIN');
	const leftMarginClass = isMobile ? '' : 'ml-4';

	return vin ? (
		<span
			className={`text-muted mr-4 ${leftMarginClass} ddc-font-size-xsmall`}
		>
			{vinLabel}# {vin}
		</span>
	) : null;
};

AltVinContent.propTypes = {
	vin: PropTypes.string,
	isMobile: PropTypes.bool
};

export default AltVinContent;
